export const CHECK_IF_PROMO_CONFIGURED_REQUEST = 'CHECK_IF_PROMO_CONFIGURED_REQUEST';
export const CHECK_IF_PROMO_CONFIGURED_SUCCESS = 'CHECK_IF_PROMO_CONFIGURED_SUCCESS';
export const CHECK_IF_PROMO_CONFIGURED_FAILURE = 'CHECK_IF_PROMO_CONFIGURED_FAILURE';
